import Ably from 'ably';

export const createAblyRestClient = (config: Ably.ClientOptions) =>
  new Ably.Rest(config);
